import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Logo from './Logo';
import SiteLinks from './SiteLinks';
import getLinksFromProps from './SiteLinks/getLinksFromProps';
import { headerSettingsShape } from './headerWidgetHelper';
import HamburgerButton from './HamburgerButton';
import LanguageButtonMobile from './LanguageSelector/LanguageButtonMobile';
import DefaultLogo from './Logo/DefaultLogo';

import styles from './MobileHeader.module.scss';
import LanguageMenuListMobile from './LanguageSelector/LanguageMenuListMobile';

const defaultImage = <DefaultLogo />;

function MobileHeader(props) {
  const [showMenu, toggleMenu] = useState(false);
  const [showLanguages, toggleLanguages] = useState(false);

  const {
    imageLink,
    imageUrl,
    mobileImageUrl,
    imageScale,
    designSettings: {
      headerBackgroundColor: backgroundColor,
      headerLinksColor,
      headerLinksHoverColor,
      languageSelectorTextColor,
      languageSelectorTextHoverColor,
      languageSelectorMenuTextHoverColor,
      languageSelectorMenuBackgroundActiveColor,
    },
    language,
    onChangeLanguage = () => {},
    ...restProps
  } = props;

  const siteLinks = getLinksFromProps(restProps);
  const showSiteLinks = props.showSiteLinks && (siteLinks.length > 0);
  const showMenuLinks = showMenu && showSiteLinks;

  const onChangeLanguageHandler = (language) => {
    onChangeLanguage(language);
    toggleLanguages(false);
  };

  const onToggleSiteLinks = () => {
    toggleMenu(!showMenu);
    toggleLanguages(false);
  };

  const onToggleLanguages = () => {
    toggleMenu(false);
    toggleLanguages(!showLanguages);
  };

  return (
    <div styleName="header" style={ { backgroundColor } }>
      <div styleName="body">
        <div styleName="logo">
          <Logo
            align="left"
            imageUrl={mobileImageUrl || imageUrl}
            imageLink={imageLink}
            imageScale={imageScale}
            defaultImage={defaultImage}
          />
        </div>
        <LanguageButtonMobile
          onClick={onToggleLanguages}
          active={showLanguages}
          color={languageSelectorTextColor}
          hoverColor={languageSelectorTextHoverColor}
        >
          {language}
        </LanguageButtonMobile>
        { showSiteLinks && (
          <HamburgerButton
            color={headerLinksColor}
            hoverColor={headerLinksHoverColor}
            active={showMenu}
            onClick={onToggleSiteLinks}
          />
        ) }
      </div>
      { showMenuLinks && (
        <div styleName="menu">
          <SiteLinks
            links={siteLinks}
            className={styles['menu-item']}
            color={headerLinksColor}
            hoverColor={headerLinksHoverColor}
            isMobile
          />
        </div>
      ) }
      { showLanguages && (
        <div styleName="menu">
          <LanguageMenuListMobile
            styleName="menu-item"
            language={language}
            onChange={onChangeLanguageHandler}
            color={headerLinksColor}
            hoverColor={languageSelectorMenuTextHoverColor}
            activeColor={languageSelectorMenuBackgroundActiveColor}
          />
        </div>
      )}
    </div>
  );
}

MobileHeader.propTypes = {
  designSettings: PropTypes.shape({
    headerBackgroundColor: PropTypes.string,
    headerLinksColor: PropTypes.string,
    headerLinksHoverColor: PropTypes.string,
  }),
  onChangeLanguage: PropTypes.func,
  ...headerSettingsShape,
};

export default React.memo(MobileHeader);



// WEBPACK FOOTER //
// ./src/js/widgets/Header/MobileHeader.js